<template>
  <div class="d-flex flex-column overflow-hidden h-100 w-100">
    <div class="tools p-1">
      <b-btn variant="outline-secondary" @click="fetchAnalytic()" v-b-popover.hover.bottomleft="'Обновить'">
        <b-icon icon="arrow-clockwise" :animation="busyAnalytic"></b-icon>
      </b-btn>

      <b-dd
        :text="currentCategory.title"
        style="max-height: 400px"
        variant="primary"
        v-b-popover.hover.bottomleft="'Фильтровать по залам'"
      >
        <b-dd-item
          v-for="item in optionCategory"
          :key="item.id"
          @click="selectCategory(item)"
          :active="item.id === filter.category_id"
        >
          {{ item.title }}
        </b-dd-item>
      </b-dd>

      <b-dd
        :text="currentCompany.title || filter.companyItem.title"
        style="max-height: 400px"
        variant="success"
        v-b-popover.hover.bottomleft="'Фильтровать по стендам'"
      >
        <b-dd-form form-class="px-2 pt-0">
          <b-form-input placeholder="Вводите для поиска" type="search"
                        v-model="filter.company_title"></b-form-input>
        </b-dd-form>

        <b-dd-item
          :active="item.id === filter.company_id"
          v-for="item in optionCompany"
          :key="item.id"
          @click="selectCompany(item)"
        >
          {{ item.title }}
        </b-dd-item>
      </b-dd>

      <b-dd
        :text="titleFilterAnalyticDate"
        style="max-height: 400px"
        variant="outline-secondary"
        v-b-popover.hover.bottomleft="'Фильтровать по дате'"
        menu-class="calendar-calendar"
      >
        <b-dd-form form-class="px-2 pt-0">
          <div class="d-flex">
            <b-calendar
              v-model="filter.analytic_date.start"
              class="px-1"
              locale="ru"
              selected-variant="success"
              today-variant="info"
              nav-button-variant="primary"
              value-as-date
              start-weekday="1"
              :max="maxAnalyticDateStart"
              :min="new Date(Date.UTC(2021, 1, 1))"
            ></b-calendar>
            <b-calendar
              v-model="filter.analytic_date.end"
              class="px-1"
              locale="ru"
              selected-variant="success"
              today-variant="info"
              nav-button-variant="primary"
              value-as-date
              start-weekday="1"
              :min="minAnalyticDateEnd"
              :max="new Date()"
            ></b-calendar>
          </div>
        </b-dd-form>

        <b-dd-item>
          <div class="d-flex justify-content-center">
            <b-btn variant="danger" class="mx-1 px-3" @click="clearFilterAnalyticDate()">Сбросить</b-btn>
            <b-btn variant="success" class="mx-1">Применить</b-btn>
          </div>
        </b-dd-item>
      </b-dd>
    </div>
    <div class="w-100 h-100">
      <v-chart
        class="w-100 h-100"
        :option="getDataset"
        :init-options="initOptions"
        ref="bar"
        theme="ovilia-green"
        autoresize
      />
    </div>
  </div>
</template>

<script>
// import "echarts/lib/chart/line"
import {use} from 'echarts/core'
import {CanvasRenderer} from 'echarts/renderers'
import {BarChart} from 'echarts/charts'
import {
  DatasetComponent,
  GridComponent,
  LegendComponent,
  TooltipComponent,
  VisualMapComponent,
} from 'echarts/components'
import VChart, {THEME_KEY} from 'vue-echarts'

use([
  CanvasRenderer,
  BarChart,
  GridComponent,
  DatasetComponent,
  LegendComponent,
  // LegendComponentOption,
  VisualMapComponent,
  TooltipComponent,
])

export default {
  name: 'AnalyticManage',
  components: {
    VChart,
  },
  provide: {
    [THEME_KEY]: 'dark',
  },
  props: {
    activityTypes: Array,
  },
  data() {
    const currentDate = new Date()
    const firstDayCurrentDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1)
    return {
      busy: {
        analytic: false,
      },
      options: {
        renderer: 'canvas',
      },
      dataset: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999',
            },
          },
        },
        toolbox: {
          feature: {
            dataView: {show: true, readOnly: false},
            magicType: {show: true, type: ['line', 'bar']},
            restore: {show: true},
            saveAsImage: {show: true},
          },
        },
        legend: {
          // orient: "vertical",
          data: ['Зал', 'Стенд'],
        },
        xAxis: [
          {
            type: 'category',
            data: [],
            axisPointer: {
              type: 'shadow',
            },
          },
        ],
        yAxis: [
          {
            type: 'value',
            name: 'Человек',
            min: 0,
            axisLabel: {
              formatter: '{value}',
            },
          },
        ],
        series: [],
      },
      items: {
        analytic: [],
        category: [],
        company: [],
      },
      filter: {
        category_id: null,
        company_id: null,
        companyItem: {},
        company_title: '',
        analytic_date: {
          start: firstDayCurrentDate,
          end: currentDate,
        },
      },
      option: {
        category: [
          {
            id: null,
            title: 'Все залы',
          },
        ],
        company: [
          {
            id: null,
            title: 'Все стенды',
          },
        ],
      },
    }
  },

  watch: {
    'filter.company_title'() {
      this.fetchCompanies()
    },
    'filter.category_id'() {
      this.fetchCompanies()
    },
    'filter.company_id'(newValue) {
      if (newValue !== null) {
        this.dataset.legend.data = [this.filter.companyItem.title]
      } else {
        this.dataset.legend.data = ['Зал', 'Стенд']
      }
    },
    'filter.analytic_date.start'() {
      this.fetchAnalytic()
    },
    'filter.analytic_date.end'() {
      this.fetchAnalytic()
    },
  },

  methods: {
    fetchAnalytic() {
      this.busy.analytic = true
      axios
        .get('https://stats.vrktpp.ru/api/analytic', {
          params: this.filterAnalyticParams,
        })
        .then(({data}) => {
          this.items.analytic = data.data
        })
        .finally(() => {
          this.busy.analytic = false
        })
    },
    fetchCategories() {
      axios.get('/webapi/company-categories').then(({data}) => {
        this.items.category = data.data
      })
    },
    fetchCompanies() {
      axios
        .post('/webapi/company/pluck', {
          title: this.filter.company_title,
          category_id: this.filter.category_id,
        })
        .then(({data}) => {
          this.items.company = data.data
        })
    },
    selectCategory(item) {
      this.filter.category_id = item.id
      this.filter.company_id = null
    },
    selectCompany(item) {
      this.filter.companyItem = item
      this.filter.company_id = item.id
    },
    clearFilterAnalyticDate() {
      this.filter.analytic_date.start = new Date(new Date().getFullYear(), new Date().getMonth(), 1)
      this.filter.analytic_date.end = new Date()
    },
    checkCompanyPluck() {
      // items.company
      return true
    },
  },

  created() {
    this.fetchAnalytic()
    this.items.category = _.sortBy(this.activityTypes, 'Name')
    // this.items.category = _.sortBy(_.filter(this.activityTypes, "View"), "Name")
    this.fetchCompanies()
  },

  computed: {
    filterAnalyticParams() {
      let start_date = null
      let end_date = null
      if (this.filter.analytic_date.start && this.filter.analytic_date.start !== '') {
        const sDate = this.filter.analytic_date.start
        start_date = sDate.getFullYear()
        start_date += (sDate.getMonth() + 1).toString().padStart(2, '0')
        start_date += sDate.getDate().toString().padStart(2, '0')
      }
      if (this.filter.analytic_date.end && this.filter.analytic_date.end !== '') {
        const eDate = this.filter.analytic_date.end
        end_date = eDate.getFullYear()
        end_date += (eDate.getMonth() + 1).toString().padStart(2, '0')
        end_date += eDate.getDate().toString().padStart(2, '0')
      }
      return {
        start_date,
        end_date,
      }
    },
    maxAnalyticDateStart() {
      let returnDate = new Date()
      if (this.filter.analytic_date.end && this.filter.analytic_date.end !== '') {
        returnDate = this.filter.analytic_date.end
      }
      return returnDate
    },
    minAnalyticDateEnd() {
      let returnDate = new Date(new Date().getFullYear(), new Date().getMonth(), 1)
      if (this.filter.analytic_date.start && this.filter.analytic_date.start !== '') {
        returnDate = this.filter.analytic_date.start
      }
      return returnDate
    },
    busyAnalytic() {
      return this.busy.analytic ? 'spin' : null
    },
    titleFilterAnalyticDate() {
      let returnDate = 'Текущий месяц'
      if (this.filter.analytic_date.start && this.filter.analytic_date.start !== '') {
        returnDate = this.filter.analytic_date.start.toLocaleDateString()
      }
      if (this.filter.analytic_date.end && this.filter.analytic_date.end !== '') {
        returnDate += ' - ' + this.filter.analytic_date.end.toLocaleDateString()
      }
      return returnDate
    },
    currentCategory() {
      const category = this.optionCategory.find((item) => item.id === this.filter.category_id)
      return category ? category : {}
    },
    currentCompany() {
      const company = this.optionCompany.find((item) => item.id === this.filter.company_id)
      return company ? company : {}
    },
    optionCategory() {
      const categories = this.items.category
        .filter((item) => {
          return item.View
        })
        .map((item) => {
          return {
            id: item.Id,
            title: item.Name,
          }
        })
      return this.option.category.concat(categories)
    },
    optionCompany() {
      const companies = this.items.company
      // .filter((item) => {
      //   return item.View
      // })
      // .map((item) => {
      //   return {
      //     id: item.Id,
      //     title: item.Name,
      //   }
      // })
      return this.option.company.concat(companies)
    },
    initOptions() {
      return {
        renderer: this.options.renderer || 'canvas',
      }
    },
    getDataset() {
      const dataset = this.dataset
      const emptyData = {
        xAxisData: [],
        room: {
          name: 'Зал',
          type: 'bar',
          data: [],
        },
        stand: {
          name: this.filter.company_id ? this.filter.companyItem.title : 'Стенд',
          type: 'bar',
          data: [],
        },
      }

      const newData = this.items.analytic.reduce((dataCollection, item) => {
        // dataCollection.xAxisData.push(item.id)
        dataCollection.xAxisData.push(item.event_date)

        if (item.event_counter.room) {
          let sum = 0
          if (this.filter.category_id !== null) {
            sum += item.event_counter.room['g_' + this.filter.category_id]
          } else {
            for (const dataCollectionKey in item.event_counter.room) {
              sum += item.event_counter.room[dataCollectionKey]
            }
          }
          dataCollection.room.data.push(sum)
        } else {
          dataCollection.room.data.push(0)
        }

        if (item.event_counter.stand) {
          let sum = 0
          if (this.filter.company_id !== null) {
            sum += item.event_counter.stand['g_' + this.filter.company_id]
          } else if (this.filter.category_id !== null) {
            for (const companyIndex in this.items.company) {
              if (item.event_counter.stand['g_' + this.items.company[companyIndex].id]) {
                sum += item.event_counter.stand['g_' + this.items.company[companyIndex].id]
              }
            }
          } else {
            for (const dataCollectionKey in item.event_counter.stand) {
              sum += item.event_counter.stand[dataCollectionKey]
            }
          }
          dataCollection.stand.data.push(sum)
        } else {
          dataCollection.stand.data.push(0)
        }

        return dataCollection
      }, emptyData)

      dataset.xAxis[0].data = newData.xAxisData
      if (this.filter.company_id) {
        dataset.series = [
          {
            name: 'Зал',
            type: 'bar',
            data: [],
          },
          newData.stand,
        ]
      } else {
        dataset.series = [newData.room, newData.stand]
      }
      return dataset
    },
  },
}
</script>

<style>
div.tools ul.dropdown-menu {
  max-height: 420px;
  min-width: 280px;
  overflow-y: auto;
  max-width: 400px;
}
</style>
